import { useSyncExternalStore } from "react";

import {
  getCameraStatusSnapshot,
  subscribeCameraStatus,
} from "../utils/cameraStatusStore";

// 구독하지 않을 때(권한 없음 등) 쓰는 빈 값 — 참조가 고정돼야 한다.
const DISABLED_SNAPSHOT = {
  statuses: [],
  statusMap: {},
  onlineCount: 0,
  loadedOnce: false,
  lastUpdated: null,
};

function noopSubscribe() {
  return () => {};
}

function getDisabledSnapshot() {
  return DISABLED_SNAPSHOT;
}

/**
 * 카메라 상태 공유 구독.
 *   enabled=false 면 구독하지 않으므로 폴링도 일어나지 않는다.
 *   (실시간 조회 권한이 없는 계정에서 불필요한 요청을 막는다)
 */
export default function useCameraStatus({ enabled = true } = {}) {
  return useSyncExternalStore(
    enabled ? subscribeCameraStatus : noopSubscribe,
    enabled ? getCameraStatusSnapshot : getDisabledSnapshot,
    getDisabledSnapshot
  );
}
